

// src/config/msalConfig.ts

import { Configuration, PublicClientApplication, PopupRequest } from '@azure/msal-browser';

const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;
const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;

if (!tenantId || !clientId) {
  console.error('Entra ID environment variables are not set.');
}

export const loginRequest: PopupRequest = {
//  scopes: ["User.Read", "openid", "profile"]
  scopes: ["openid", "profile", "email", "User.Read", "api://6cfc0240-69d9-4ce6-8128-b05182d95d09/access_as_user"]

};

// =================================================================
// == THIS SECTION IS NOW CORRECT
// =================================================================
export const apiScopes = {
  scopes: ['api://6cfc0240-69d9-4ce6-8128-b05182d95d09/access_as_user']
};
// =================================================================

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || '',
    authority: `https://login.microsoftonline.com/${tenantId}/v2.0`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: console.debug(message); break;
          case 1: console.info(message); break;
          case 2: console.warn(message); break;
          case 3: console.error(message); break;
        }
      },
      piiLoggingEnabled: false
    }
  }
};

let msalInstance: PublicClientApplication | null = null;
if (typeof window !== 'undefined' && !msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
}

export { msalInstance };